import { render } from "./BlCollectionAdd.vue?vue&type=template&id=73644178"
import script from "./BlCollectionAdd.vue?vue&type=script&lang=js"
export * from "./BlCollectionAdd.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__